import { Suspense, lazy } from "react";
import { useRoutes, useLocation } from "react-router-dom";
import routes from "./routes/routes";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./ScrollToTop";
import "./assets/globalStyles/styles.scss";
// import { AnimatePresence, motion } from "framer-motion";
import { createPortal } from "react-dom";
import OfflineOverlay from "./components/OfflineOverlay";

const CommmunityNotificationProvider = lazy(() =>
  import("./Context/notificationContext").then((module) => ({
    default: module.CommmunityNotificationProvider,
  })),
);

const CRNotificationProvider = lazy(() =>
  import("./Context/CRNotificationContext").then((module) => ({
    default: module.CRNotificationProvider,
  })),
);

const App = () => {
  const content = useRoutes(routes);
  const location = useLocation(); //  " " Get the current location

  // Only use notification provider for dashboard routes
  const isDashboardRoute =
    location.pathname.startsWith("/dashboard") ||
    location.pathname.startsWith("/employee/dashboard");

  return (
    <>
      <OfflineOverlay />
      {isDashboardRoute ? (
        <Suspense fallback={<div />}>
          <CommmunityNotificationProvider>
            <CRNotificationProvider>
              <ScrollToTop />
              <Suspense fallback={null}>{content}</Suspense>
              {createPortal(
                <Toaster containerStyle={{ zIndex: 9999999 }} />,
                document.body,
              )}
            </CRNotificationProvider>
          </CommmunityNotificationProvider>
        </Suspense>
      ) : (
        <>
          <ScrollToTop />
          <Suspense fallback={null}>{content}</Suspense>
          {createPortal(
            <Toaster containerStyle={{ zIndex: 9999999 }} />,
            document.body,
          )}
        </>
      )}
    </>
  );
};

export default App;
